import { number, object, string } from "yup"
const addressModel = object({
  id: number(),
  latitude: number().required("Please Select the location!").label("Latitude"),
  longitude: number()
    .required("Please Select the location!")
    .label("Longitude"),
  village: string().min(2).required().label("Village"),
  taluka: string().nullable(),
  district: string().nullable(),
  state: string().nullable(),
  pincode: string()
    .matches(/^[0-9]{6}$/, "Please enter valid pincode")
    .transform(v => (v === "" ? null : v))
    .nullable(),
}).typeError("Please enter a valid address!")
export default addressModel
